import { render, staticRenderFns } from "./MatchEndedSurvey.vue?vue&type=template&id=f4e72932&"
import script from "./MatchEndedSurvey.vue?vue&type=script&lang=js&"
export * from "./MatchEndedSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports